<template>
  <Content>
    <section class="faq-section py-4 py-lg-5 px-3 px-md-4">
      <div class="container">
        <!-- تیتر و هدر بخش -->
        <div
          class="text-center mb-4 mb-lg-5"
        >
          <div
            class="section-badge d-inline-flex align-items-center gap-2 mb-2"
          >
            <i class="bi bi-question-circle-fill"></i>
            <span>{{ currentLang.badge }}</span>
          </div>
          <h1 class="section-title">{{ currentLang.title }}</h1>
          <p class="section-desc text-muted mx-auto">
            {{ currentLang.subtitle }}
          </p>
        </div>

        <!-- آکاردئون سوالات -->
        <div
          class="accordion mx-auto"
          id="faqAccordion"
          :style="{ maxWidth: '800px' }"
        >
          <div
            v-for="(item, index) in currentLang.items"
            :key="index"
            class="accordion-item"
          >
            <h2 class="accordion-header" :id="'faqHeader-' + index">
              <button
                class="accordion-button collapsed d-flex align-items-center"
                type="button"
                data-bs-toggle="collapse"
                :data-bs-target="'#faqCollapse-' + index"
                aria-expanded="false"
                :aria-controls="'faqCollapse-' + index"
                :dir="lang === 'fa' ? 'rtl' : 'ltr'"
              >
                <i
                  class="bi bi-plus-circle-fill me-2 text-primary flex-shrink-0"
                ></i>
                <span class="flex-grow-1">{{ item.question }}</span>
              </button>
            </h2>
            <div
              :id="'faqCollapse-' + index"
              class="accordion-collapse collapse"
              :aria-labelledby="'faqHeader-' + index"
              data-bs-parent="#faqAccordion"
            >
              <div class="accordion-body" :dir="lang === 'fa' ? 'rtl' : 'ltr'">
                <p v-html="item.answer"></p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>

    <footerAdmin></footerAdmin>
  </Content>
</template>

<script setup>
import {  computed } from "vue";

import Content from "@/components/AdminContent.vue";
import footerAdmin from "@/components/AdminFooter.vue";

import { lang } from "@/plugins/lang";

import enText from "@/locales/en/FAQPage";
import faText from "@/locales/fa/FAQPage";

const translations = {
  en: enText,
  fa: faText,
};

const currentLang = computed(() => translations[lang.value]);
</script>






<style scoped>
.section-badge {
  background: rgba(70, 127, 255, 0.12); /* رنگ آبی ملایم */
  color: #467bff;
  font-weight: 700;
  font-size: 0.85rem;
  padding: 6px 14px;
  border-radius: 50px;
}

.section-title {
  font-size: 1.85rem;
  font-weight: 800;
  color: #18325b;
}

.section-desc {
  max-width: 650px;
  font-size: 0.95rem;
  line-height: 1.7;
}

/* استایل آکاردئون Bootstrap */
.accordion-item {
  border: 1px solid #e2e8f0;
  border-radius: 16px !important;
  margin-bottom: 16px;
  overflow: hidden; /* برای اینکه گوشه‌های گرد درست نمایش داده بشن */
}

.accordion-item:last-of-type {
  margin-bottom: 0;
}

.accordion-header {
  background-color: #ffffff;
}

.accordion-button {
  font-size: 1.05rem;
  font-weight: 700;
  color: #1e293b;
  padding: 1rem 1.5rem;
  background-color: #ffffff;
  border-radius: 16px; /* اطمینان از گرد بودن */
  box-shadow: none !important; /* حذف سایه پیش‌فرض */
}

.accordion-button:not(.collapsed) {
  color: #009688; /* رنگ عنوان در حالت باز */
  background-color: #f0fdf4; /* پس‌زمینه سبز ملایم در حالت باز */
}

.accordion-button::after {
  background-image: url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' fill='%23467bff'%3e%3cpath fill-rule='evenodd' d='M8 15A7 7 0 1 0 8 1a7 7 0 0 0 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z'/%3e%3cpath fill-rule='evenodd' d='M8 11a.5.5 0 0 1-.5-.5V4a.5.5 0 0 1 1 0v6.5a.5.5 0 0 1-.5.5z'/%3e%3c/svg%3e");
  background-size: 1.25rem;
  flex-shrink: 0;
  margin-left: auto; /* برای هدایت به سمت راست در راست‌چین */
  margin-right: 0; /* حذف حاشیه راست پیش‌فرض */
}

.accordion-button:not(.collapsed)::after {
  background-image: url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' fill='%23009688'%3e%3cpath fill-rule='evenodd' d='M8 15A7 7 0 1 0 8 1a7 7 0 0 0 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z'/%3e%3cpath fill-rule='evenodd' d='M8 11a.5.5 0 0 1-.5-.5V4a.5.5 0 0 1 1 0v6.5a.5.5 0 0 1-.5.5z'/%3e%3c/svg%3e");
}

/* استایل محتوای آکاردئون */
.accordion-collapse .accordion-body {
  padding: 1.5rem;
  font-size: 0.95rem;
  line-height: 1.7;
  color: #475569;
}

/* آیکون‌های پلاس/ماینوس */
.accordion-button .bi-plus-circle-fill {
  font-size: 1.2rem;
  margin-left: 0.5rem; /* فاصله با سوال */
  transition: transform 0.2s ease-in-out;
}

.accordion-button:not(.collapsed) .bi-plus-circle-fill {
  transform: rotate(45deg); /* تبدیل پلاس به ضربدر */
  color: #009688 !important;
}

/* responsive adjustments */
@media (max-width: 767.98px) {
  .accordion-button {
    font-size: 1rem;
    padding: 0.8rem 1.2rem;
  }
  .accordion-collapse .accordion-body {
    padding: 1.2rem;
    font-size: 0.9rem;
  }
}
</style>












































 

